const VALIDATION_ERROR_SELECTOR = "[data-validation-error]"
const MAXIMUM_FRAMES_TO_WAIT_FOR_ERROR_RENDERING = 3

export const scrollToFirstValidationError = (progressNoteId: string) => {
  // The form state that renders the errors commits in a scheduler task after the awaited trigger()
  // calls, and that task is not guaranteed to run before the next frame, so keep looking for a few
  // frames and settle for the progress note itself if none of them shows an error.
  let remainingFrames = MAXIMUM_FRAMES_TO_WAIT_FOR_ERROR_RENDERING

  const scrollWhenErrorIsRendered = () => {
    remainingFrames -= 1

    const progressNoteElement = document.getElementById(progressNoteId)
    const firstValidationErrorElement = progressNoteElement?.querySelector(VALIDATION_ERROR_SELECTOR)

    if (!firstValidationErrorElement && remainingFrames > 0) {
      requestAnimationFrame(scrollWhenErrorIsRendered)
      return
    }

    const scrollTarget = firstValidationErrorElement ?? progressNoteElement

    scrollTarget?.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  requestAnimationFrame(scrollWhenErrorIsRendered)
}
